export enum OttopilotTargetsWorkspaceCapabilityAccessOperation {
    create = "910042b2-5c4b-4903-bc70-49b9c8078e07",
    read = "eafb3440-b00d-4880-8931-64678cb0c749",
    update = "a0c0c0b2-1482-457c-affb-be5415aac706",
    delete = "1db36ee0-9233-44e3-94c0-6c861719c2ee",
}
